import React from 'react';
import { NavLink } from 'react-router-dom';
import SiteHeader from '../../Components/Shared/SiteHeader';
import Footer from '../../Components/1st page/Footer';
import institutePhoto from '../../Assets/EMEI FRont logo.jpeg';
import chandrimaPhoto from '../../Assets/Profile pics/Chandrimamaam.jpeg';
import principalPhoto from '../../Assets/Profile pics/principalsir.jpeg';
import sayanPhoto from '../../Assets/Profile pics/SayanSir2.0.jpeg';
import ceoPhoto from '../../Assets/Profile pics/MrsM.sen.jpeg';
import './AboutUs.css';

const leaders = [
  {
    name: 'Mr. S.K. Sen',
    role: 'Principal',
    photo: principalPhoto,
    photoAlt: 'Mr. S.K. Sen, Principal of EMEI',
    qualification: 'Mechanical Engineer &middot; Former Government ITI professor',
    description: 'With decades of experience in academic management, Mr. Sen guides the institute’s academic direction and supports a focused learning environment.',
    accent: 'blue',
  },
  {
    name: 'Mrs. M. Sen',
    role: 'Chief Executive Officer',
    photo: ceoPhoto,
    photoAlt: 'Mrs. M. Sen, Chief Executive Officer of EMEI',
    qualification: 'Founder & Trustee',
    description: 'Mrs. M. Sen brings 14+ years of business and management leadership to EMEI and helps guide the institute’s growth and direction.',
    accent: 'green',
  },
  {
    name: 'Mr. Sayan Sen',
    role: 'Managing Director',
    photo: sayanPhoto,
    photoAlt: 'Mr. Sayan Sen, Managing Director of EMEI',
    qualification: 'Electronic & Robotics Engineer',
    description: 'Mr. Sen brings experience across engineering, teaching, counselling, and marketing to the institute’s management and development.',
    accent: 'blue',
  },
  {
    name: 'Mrs. Chandrima Sen',
    role: 'General Manager',
    photo: chandrimaPhoto,
    photoAlt: 'Mrs. Chandrima Sen, General Manager of EMEI',
    qualification: 'BA (Hons), LLB &middot; Professional advocate',
    description: 'Mrs. Sen brings legal and finance experience to EMEI, supporting the institute’s day-to-day leadership and its commitment to students.',
    accent: 'green',
  },
];

const values = [
  { number: '01', title: 'Learn by doing', copy: 'Connect learning with practical work and real skills.' },
  { number: '02', title: 'Guidance that matters', copy: 'Get support from educators who care about your progress.' },
  { number: '03', title: 'Prepare for what’s next', copy: 'Build knowledge and confidence for the next step in your career.' },
];

export default function AboutUs() {
  return (
    <div className="about-page">
      <SiteHeader>
        <li><NavLink end to="/">Home</NavLink></li>
        <li><NavLink end to="/about">About Us</NavLink></li>
        <li><NavLink end to="/career">Career</NavLink></li>
        <li><NavLink end to="/gallery">Gallery</NavLink></li>
        <li><NavLink end to="/login"><button type="button">Sign in</button></NavLink></li>
      </SiteHeader>

      <main>
        <section className="about-hero" aria-labelledby="about-hero-title">
          <div className="about-hero__glow about-hero__glow--one" aria-hidden="true" />
          <div className="about-hero__glow about-hero__glow--two" aria-hidden="true" />
          <div className="about-shell about-hero__layout">
            <div className="about-hero__copy">
              <span className="about-eyebrow"><span /> ABOUT EMEI</span>
              <h1 id="about-hero-title">People behind a <em>brighter tomorrow.</em></h1>
              <p>At EMEI, leadership and educators work together to create a supportive learning environment where students can build practical skills, knowledge, and confidence.</p>
              <a className="about-button" href="#leadership">Meet our leadership <span aria-hidden="true">↘</span></a>
              <div className="about-hero__note"><span className="about-hero__note-mark" aria-hidden="true">“</span><span>Touch the world of success</span></div>
            </div>

            <figure className="about-hero__photo-wrap">
              <img src={institutePhoto} alt="The EMEI institute building" className="about-hero__photo" />
              <figcaption><span className="about-hero__photo-dot" /> EMEI campus</figcaption>
            </figure>
          </div>
          <div className="about-hero__bottom-line" aria-hidden="true" />
        </section>

        <section className="about-leadership about-shell" id="leadership" aria-labelledby="leadership-title">
          <div className="about-section-heading">
            <span className="about-eyebrow"><span /> OUR LEADERSHIP</span>
            <h2 id="leadership-title">Guided by experience.<br /><em>Focused on people.</em></h2>
            <p>Meet the leaders helping shape the EMEI learning community.</p>
          </div>
          <div className="about-leader-grid">
            {leaders.map((leader) => (
              <article className={`about-leader-card about-leader-card--${leader.accent}`} key={leader.name}>
                <div className="about-leader-card__photo-wrap">
                  <img src={leader.photo} alt="" aria-hidden="true" className="about-leader-card__backdrop" />
                  <img src={leader.photo} alt={leader.photoAlt} className="about-leader-card__photo" loading="lazy" />
                  <span className="about-leader-card__role"><span aria-hidden="true">✦</span>{leader.role}</span>
                </div>
                <div className="about-leader-card__content">
                  <h3>{leader.name}</h3>
                  <p className="about-leader-card__qualification">{leader.qualification}</p>
                  <p className="about-leader-card__description">{leader.description}</p>
                  <div className="about-leader-card__rule" aria-hidden="true"><span /></div>
                </div>
              </article>
            ))}
          </div>
        </section>

        <section className="about-story" aria-labelledby="about-story-title">
          <div className="about-shell about-story__layout">
            <div className="about-story__copy">
              <span className="about-eyebrow"><span /> OUR INSTITUTE</span>
              <h2 id="about-story-title">About <em>EMEI</em></h2>
              <p className="about-story__lead">A place to learn, practise, and move forward with purpose.</p>
              <p>EMEI is an education and training institute focused on helping learners develop useful knowledge and practical abilities. Our goal is to make learning approachable, relevant, and connected to each student’s ambitions.</p>
              <p>With guidance from our academic team and leadership, students are encouraged to keep building their skills and take confident steps toward their future.</p>
              <div className="about-values">
                {values.map((value) => (
                  <div className="about-value" key={value.number}>
                    <span className="about-value__number">{value.number}</span>
                    <div><h3>{value.title}</h3><p>{value.copy}</p></div>
                  </div>
                ))}
              </div>
            </div>
            <div className="about-story__visual">
              <img src={institutePhoto} alt="EMEI campus and achievements" loading="lazy" />
              <div className="about-story__caption"><span>EMEI</span><span>Campus &amp; achievements</span></div>
              <div className="about-story__seal" aria-hidden="true"><span>EMEI</span><small>Learn · Practise · Grow</small></div>
            </div>
          </div>
        </section>

        <section className="about-cta" aria-label="Explore EMEI">
          <div className="about-shell about-cta__inner">
            <div><span className="about-eyebrow">YOUR NEXT CHAPTER</span><h2>Let’s make it a bright one.</h2><p>Explore EMEI and find a path that fits your goals.</p></div>
            <NavLink className="about-button about-button--light" to="/">Explore EMEI <span aria-hidden="true">↗</span></NavLink>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}